import { render } from "./SelMf.vue?vue&type=template&id=04a37d56&scoped=true"
import script from "./SelMf.vue?vue&type=script&lang=js"
export * from "./SelMf.vue?vue&type=script&lang=js"

import "./SelMf.vue?vue&type=style&index=0&id=04a37d56&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a37d56"]])

export default __exports__